/**
 * export file for feature product
 * Author: Chris
 * CreatedAt: 2021-3-23
 */

export { default as FeaturedProduct } from './FeaturedProduct';
